import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ConnectedUserContext } from '../connectedUser-context';

import Axios from 'axios';
import moment from 'moment';

// Router: General
import AdminGeneral from './AdminGeneral';
import AdminSeasons from './seasons/AdminSeasons';

// Auth
import Users from '../users/Users';
import { ADMIN_LVLS } from '../shared/constants/constants';

const getAdminNameByLevel = (lvl) => {
  return ADMIN_LVLS.find(item => item.lvl === lvl)?.name || "Niveau inconnu";
};

// Refs:  React router and tabs
// https://github.com/reactstrap/reactstrap/issues/83#issue-168537815
// https://github.com/reactstrap/reactstrap/issues/298
// https://codesandbox.io/s/github/browniefed/tmp/tree/reactRouterDynamicRoutes/?from-embed
// https://stackoverflow.com/questions/51203888/reactjs-routing-to-different-tabs

// ADMIN MAINTENANCE SPECIAL CONSTANT
const ADMIN_MAINTENANCE_RESTRICTED_TO_MASTER = false;


class Admin extends React.Component {

	static contextType = ConnectedUserContext;

  constructor(props) {
		super(props);
		this.state = {
			activeSection: 'seasons',
		};
	
		this.dispAdminPageAccess = this.dispAdminPageAccess.bind(this);
		this.dispAdminPage = this.dispAdminPage.bind(this);
		//this.admGenClicked = this.admGenClicked.bind(this);
		//this.admSeasonClicked = this.admSeasonClicked.bind(this);
	}

	render() {
		// const { auth0 } = this.props;
		// const { isAuthenticated } = auth0;
		// const { user: authUser } = auth0;
	  const { connectedUser } = this.context;
    console.log('%cADMIN: render - connectedUser:', 'color: red;', connectedUser);

		return (
			<div className="animated fadeIn">
			<div className="row row-margin-bottom-100">
			<div className="col-md-12 col-xs-12">
				<h3>Menu Administrateur</h3>
				<br/>
				{/* isAuthenticated ? this.dispAdminPageAccess() : this.dispNoAccess() */}
				{connectedUser ? this.dispAdminPageAccess() : this.dispNoAccess()}
			</div>
			</div>
			</div>
		)
	}

	renderSection() {
		const { activeSection } = this.state;
		switch (activeSection) {
			case 'general':
				return <AdminGeneral />;
			case 'seasons':
			default:
				return <AdminSeasons refreshConnectedUser={this.props.refreshConnectedUser} />;
		}
	}

	dispNoAccess() {
    console.log('%cADMIN - SHOW DISP NO ACCESS HERE', 'color: red;');
		return (
			<div>
				<p>Vous devez être connecté pour visualiser le menu Admin.<br/>
				Cliquez sur <b>Se connecter</b> dans la barre de gauche.<br/></p>
			</div>
		)
	}

	dispAdminPageAccess() {
    const { connectedUser } = this.context;
    if (!connectedUser) { return; }

    console.log("ADMIN: dispAdminPageAccess - connectedUser", connectedUser)

		let adminAccesOK = (!ADMIN_MAINTENANCE_RESTRICTED_TO_MASTER || connectedUser.isMasterAdmin);

		if (adminAccesOK) {
			return (this.dispAdminPage());
		} else if (ADMIN_MAINTENANCE_RESTRICTED_TO_MASTER)  {
			return ( <div><p>Section Admin en maintenance<br/>Revenez un peu plus tard. Merci.</p></div> );
		} else {
			return ( <div><p>Section à accès restreint</p></div> );
		}
	}

	dispAdminPage() {
    const { connectedUser } = this.context;
    if (!connectedUser) { return; }
    const { user } = connectedUser;

		let adminLvLTxt = getAdminNameByLevel(connectedUser.adminValidatedLevel);

		return (
			<div>
				{/* ----------------- UTILISATEUR ---------------- */}
				<div className="row">
					<div className="col-md-1 col-xs-1">
						{/* <img className="img-profile-token" src={authUser.picture}/> */}
						<img className="img-profile-token" src={user.picture}/>
					</div>
					<div className="col-md-6 col-xs-6">
						<h5><b>Utilisateur:</b> {user.name}</h5>
						<h5><b>Niveau:</b> {connectedUser.adminValidatedLevel} - [{adminLvLTxt}]</h5>
					</div>
				</div>
				<br/>

				{this.dispAdminButtons(connectedUser.isMasterAdmin)}

				{/* CONTENT */}
        {connectedUser ? this.renderSection(): null}

			</div>
		)
	}

	dispAdminButtons(isMasterAdmin) {
    const { activeSection } = this.state;

		let genBtnClass = 'btn-primary';
		let seasonsBtnClass = 'btn-secondary';

		if (activeSection === 'seasons') {
			genBtnClass = 'btn-secondary';
			seasonsBtnClass = 'btn-primary';			
		}

		if (isMasterAdmin) {
			return (
				<div className="row">
				<div className="col-md-12">

	        {/* Menu de navigation admin */}
					<button className={"btn " + seasonsBtnClass + " adminMenuButton1 btn-margin-right-10"} 
						onClick={() => this.setState({ activeSection: 'seasons' })}>
						Admin - Ligues et Saisons
					</button>
					<button className={"btn " + genBtnClass + " adminMenuButton1 btn-margin-right-10"}
						onClick={() => this.setState({ activeSection: 'general' })}>
						Admin Général
					</button>
					<br/><br/>
				</div>
				</div>
			)
		}
	}

};

// Utilisation combinée de withRouter et withAuth0
// export default withAuth0(withRouter(Admin));
export default Admin;